import {useEffect} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {getBrowserClient} from "@/lib/supabase";

export function CustomerReferenceNavigator() {
  const {pathname} = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    let cancelled = false;
    const handle = async (event: Event) => {
      const {customerId, mergedInto} = (event as CustomEvent<{customerId?: string; mergedInto?: string}>).detail;
      if (!customerId || pathname !== `/customers/${customerId}`) return;
      if (event.type === "customer-deleted") {
        navigate("/", {replace: true});
        return;
      }
      if (!mergedInto) return;
      // DETAIL は直近のマージ先。連鎖が伸びていた場合も有効な final だけへ案内する。
      const {data, error} = await getBrowserClient().rpc("resolve_customer_final", {p_customer_id: mergedInto});
      const final = data?.[0];
      if (!cancelled && !error && final?.status === "active" && final.final_id) {
        navigate(`/customers/${final.final_id}`, {replace: true});
      }
    };
    const listener = (event: Event) => {
      void handle(event);
    };
    window.addEventListener("customer-merged", listener);
    window.addEventListener("customer-deleted", listener);
    return () => {
      cancelled = true;
      window.removeEventListener("customer-merged", listener);
      window.removeEventListener("customer-deleted", listener);
    };
  }, [pathname, navigate]);
  return null;
}
